window.WOODUI = (() => {

  /* =========================
     IMAGE COLOR COUNT
  ========================= */

  function getImageColorCount(img) {

    const canvas =
      document.createElement("canvas");

    const ctx =
      canvas.getContext("2d");

    if (!ctx) return 0;

    if (
      !img.naturalWidth ||
      !img.naturalHeight
    ) {
      return 0;
    }

    const maxSize = 150;

    canvas.width = maxSize;

    canvas.height =
      (img.naturalHeight / img.naturalWidth) *
      maxSize;

    ctx.drawImage(
      img,
      0,
      0,
      canvas.width,
      canvas.height
    );

    const data =
      ctx.getImageData(
        0,
        0,
        canvas.width,
        canvas.height
      ).data;

    const colorSet = new Set();

    for (let i = 0; i < data.length; i += 40) {

      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];

      const key =
        `${Math.round(r / 60)},${Math.round(g / 60)},${Math.round(b / 60)}`;

      colorSet.add(key);

    }

    return colorSet.size;

  }

  /* =========================
     COLOR UI
  ========================= */

  function updateColorUI() {

    const els = window.els;

    if (
      !els ||
      !els.liveImage ||
      !els.liveImage.src ||
      !els.liveImage.src.includes("data:")
    ) {

      if (els?.colorInfoBox) {
        els.colorInfoBox.style.display = "none";
      }

      if (els?.colorPalette) {
        els.colorPalette.innerHTML = "";
      }

      return;

    }

    const colorCount =
      window.cachedColorCount || 0;

    const price =
      window.WOODPricing.getColorPrice(colorCount);

    let complexity = "Simple Design";

    if (
      colorCount >= 5 &&
      colorCount <= 8
    ) {
      complexity = "Moderate Design";
    }

    if (colorCount > 8) {
      complexity = "Complex Design";
    }

    if (els.colorInfoBox) {
      els.colorInfoBox.style.display = "flex";
    }

    if (els.colorCountText) {

      els.colorCountText.textContent =
        `🎨 ${colorCount} colors`;

    }

    if (els.colorPriceText) {

      els.colorPriceText.textContent =
        `+$${price}`;

    }

    if (els.colorComplexityText) {

      els.colorComplexityText.textContent =
        complexity;

    }

    if (els.scaleFill) {

      let percent = 20;

      if (colorCount >= 3) percent = 40;
      if (colorCount >= 5) percent = 65;
      if (colorCount >= 8) percent = 100;

      els.scaleFill.style.width =
        percent + "%";

    }

  }

  /* =========================
     COLOR PALETTE
  ========================= */

  function renderColorPalette(img) {

    const els = window.els;

    if (!els?.colorPalette) return;

    els.colorPalette.innerHTML = "";

    const canvas =
      document.createElement("canvas");

    const ctx =
      canvas.getContext("2d");

    if (!ctx) return;

    canvas.width = 80;
    canvas.height = 80;

    try {

      ctx.drawImage(
        img,
        0,
        0,
        80,
        80
      );

    } catch(err) {

      console.error(
        "Palette render failed:",
        err
      );

      return;

    }

    const data =
      ctx.getImageData(
        0,
        0,
        80,
        80
      ).data;

    const colors = {};

    for (let i = 0; i < data.length; i += 32) {

      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];

      const key =
        `${Math.round(r / 40) * 40},${Math.round(g / 40) * 40},${Math.round(b / 40) * 40}`;

      colors[key] =
        (colors[key] || 0) + 1;

    }

    const topColors =
      Object.entries(colors)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6);

    topColors.forEach(([color]) => {

      const swatch =
        document.createElement("div");

      swatch.className =
        "palette-swatch";

      swatch.style.background =
        `rgb(${color})`;

      els.colorPalette.appendChild(swatch);

    });

  }

  /* =========================
   INIT
========================= */

function init() {

  const els = window.els;

  if (!els) return;

  /* =========================
     MULTI-STEP BUILDER
  ========================= */

  const steps =
    document.querySelectorAll(".builder-step");

  let currentStep = 0;

  function showStep(index) {

    steps.forEach((step, i) => {

      step.style.display =
        i === index ? "block" : "none";

    });

  }

  showStep(0);

  document.querySelectorAll(".next-step")
    .forEach(btn => {

      btn.addEventListener("click", () => {

        if (currentStep < steps.length - 1) {

          currentStep++;

          showStep(currentStep);

        }

      });

    });

  document.querySelectorAll(".prev-step")
    .forEach(btn => {

      btn.addEventListener("click", () => {

        if (currentStep > 0) {

          currentStep--;

          showStep(currentStep);

        }

      });

    });

  /* IMAGE UPLOAD */

  if (els.uploader) {

    els.uploader.addEventListener("change", function () {

      const file = this.files[0];

      if (!file) return;

      const reader = new FileReader();

      reader.onload = function (e) {

        els.liveImage.onload = function () {

          window.cachedColorCount =
            getImageColorCount(els.liveImage);

          updateColorUI();

          renderColorPalette(els.liveImage);

          if (window.WOODPricing?.updatePrice) {
            window.WOODPricing.updatePrice();
          }

        };

        els.liveImage.src = e.target.result;

      };

      reader.readAsDataURL(file);

    });

  }

}

/* =========================
   EXPORTS
========================= */

return {

  init,
  getImageColorCount,
  updateColorUI,
  renderColorPalette

};

})();